import type { ConvexActionClient } from './convexTypes';
import { api } from '../../convex/_generated/api';

export interface LLMClassificationResult {
  isPiracy: boolean;
  confidence: number;
  reasoning: string;
}

export interface PageToClassify {
  url: string;
  domain: string;
  pageTitle: string;
  pageText: string;
}

export class OpenRouterClient {
  private apiKey: string;
  private convexClient: ConvexActionClient;

  constructor(apiKey: string, convexClient: ConvexActionClient) {
    this.apiKey = apiKey;
    this.convexClient = convexClient;
  }

  async classify(
    url: string,
    domain: string,
    pageTitle: string,
    pageText: string,
    contentTitle: string
  ): Promise<LLMClassificationResult | null> {
    try {
      const result = await this.convexClient.action(api.llmClassifier.classifyWithLLM, {
        url,
        domain,
        pageTitle,
        contentTitle,
        pageText,
      });

      return result as LLMClassificationResult | null;
    } catch (error: any) {
      console.error(`❌ LLM classification error for ${url}:`, error.message);
      return null;
    }
  }

  async classifyMultiple(
    pages: PageToClassify[],
    contentTitle: string,
    options?: { concurrency?: number }
  ): Promise<(LLMClassificationResult | null)[]> {
    try {
      const results = await this.convexClient.action(api.llmClassifier.classifyMultipleWithLLM, {
        pages,
        contentTitle,
        concurrency: options?.concurrency,
      });

      return results as (LLMClassificationResult | null)[];
    } catch (error: any) {
      console.error(`❌ LLM batch classification error:`, error.message);
      return [];
    }
  }
}
